import { InjectionToken } from "@angular/core";
import { IAppConfiguration } from "@logex/framework/lg-application";
import { SidebarHelpStandardLinks } from "@logex/framework/lg-layout";

export const APP_HELP_LINKS = new InjectionToken<SidebarHelpStandardLinks>("AppHelpLinks");

// Configuration
export interface ServicesConfiguration {
    authentication: {
        authority: string;
        clientId: string;
        audience: string;
        type?: "auth0" | "generic";
    };
    configuration: string;
    userSettings: string;
    authorization: string;
    application: string;
}

export interface AppStaticConfiguration {
    instance: string;
    // please note, that Production ,Execution and Test might be with capitalized first letter due to Octopus setup
    environment: "development" | "execution" | "production" | string;
    availableLanguages: string;
    defaultLanguage: string;
    fallbackLanguage: string;
    currency: string;

    applicationInsights: Partial<{
        instrumentationKey: string;
        excludeDomains: string[];
    }>;

    services: Partial<ServicesConfiguration>;
}

export interface AppDynamicConfiguration {
    services: Partial<ServicesConfiguration>;

    applicationInsights: {
        instrumentationKey: string;
        excludeDomains: string[];
    };

    userFlow: {
        environmentKey: string;
        contentId: string;
    };

    matomo: {
        statUrl: string;
        siteId: number;
    };

    helpLinks: SidebarHelpStandardLinks;
}

export type AppCombinedConfiguration = AppStaticConfiguration &
    AppDynamicConfiguration & { services: ServicesConfiguration };

export interface AppConfiguration extends IAppConfiguration {}

export class AppConfiguration implements IAppConfiguration {
    applicationInsightsInstrumentationKey: string;
    full: AppCombinedConfiguration;

    constructor() {
        this.ready = new Promise<void>(resolve => {
            this.markReady = resolve;
        });
    }

    markReady: () => void;
}
